export default __webpack_public_path__ + "static/projectTwo-b4f368bdf7b4c16928366de1a9079b3b.jpg";